import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { LegalAssociationsViolenceItemModel } from '../types';

export const legalAssociationsViolenceItemValidator: ValidateJSModel<LegalAssociationsViolenceItemModel> = {
  Organization: { presence: true, hasValue: true },

  Address: { presence: true, location: { validator: locationAddressModelValidator } },

  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Positions: (value, attributes) => {
    if (attributes?.PositionsNotApplicable?.applicable === false) {
      return {};
    }

    return { presence: true, hasValue: true };
  },

  PositionsNotApplicable: {},

  Contributions: (value, attributes, attributeName, options) => {
    if (attributes?.ContributionsNotApplicable?.applicable === false) {
      return {};
    }
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        model: {
          validator: currencyModelValidator,
        },
      };
    }
    return { presence: true, hasValue: true };
  },

  ContributionsNotApplicable: {},

  Reasons: { presence: true, hasValue: true },
};
